var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.stockEntries !== null && _vm.stockEntries !== undefined && _vm.stockEntries.length > 0)?_c('v-list',[_vm._l((_vm.stockEntries),function(entry,index){return [_c('StockListItem',{key:index,attrs:{"entry":entry}}),(_vm.stockEntries.length - 1 > index)?_c('v-divider',{key:index + 'div'}):_vm._e()]})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }